import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Sl3AnagrafService} from '../../../general-services/service-sl3-anagraf/sl3-anagraf.service';
import {L1Model} from '../../../../models/L1Model';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-l1-anagraf',
  templateUrl: './new-sl3-anagraf.component.html',
  styleUrls: ['./new-sl3-anagraf.component.scss']
})
export class NewSl3AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  l1: L1Model;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private sl3AnagrafService: Sl3AnagrafService) {
    super();

    this.l1 = new L1Model();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.l1.cod, [Validators.required]],
      description: [this.l1.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL3_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.l1.cod = this.formValidator.value.cod;
      this.l1.description = this.formValidator.value.description;
      this.saveSubscribe = this.sl3AnagrafService.save(this.sl3AnagrafService.baseUrl, this.l1).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, SL3 Cod already exists', 'Warning');
          } else {
            toastr.success('Element added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL3_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
